import * as Yup from 'yup'

export function getValidation(stepName) {
    const validationSchemas = {
        reimbursement_account: Yup.object({
            bank: Yup.mixed()
                .required("Please select a bank from the dropdown list")
                .test("has-id", "Please select a bank from the dropdown list", function (value) {
                    if (!value || typeof value !== "object") return false
                    if (!value.id) return false
                    // Bank from dropdown also needs a valid routing number
                    const routingNumber = String(value.routingNumber || "").replace(/\D/g, "")
                    return routingNumber.length === 9
                }),
            routingNumber: Yup.string()
                .test("is-valid", "Routing number is required", function (value) {
                    // This is a hidden field, validation is handled by bank field
                    return true
                }),
            nickname: Yup.string()
                .required("Nickname is required")
                .trim()
                .min(1, "Nickname is required"),
            accountType: Yup.string()
                .required("Account type is required")
                .oneOf(["checking", "savings"], "Account type must be checking or savings"),
            accountNumber: Yup.string()
                .required("Account number is required")
                .test("is-valid-length", "Account number must be between 4 and 17 digits", function (value) {
                    if (!value) return false
                    const digits = String(value).replace(/\D/g, "")
                    return digits.length >= 4 && digits.length <= 17
                }),
            isBillingAccount: Yup.string()
                .required("Please select whether to charge service fees to this account")
                .oneOf(["Yes", "No"], "Please select Yes or No"),
        }),
        reimbursements: Yup.object({
            routingNumber: Yup.string()
                .length(9, "Routing number must be 9 digits")
                .required("Routing number is required"),
            accountNumber: Yup.string()
                .min(4, "Account number must be at least 4 digits")
                .max(17, "Account number must be at most 17 digits")
                .required("Account number is required"),
            accountNumberConfirm: Yup.string()
                .oneOf([Yup.ref('accountNumber')], "Account numbers must match")
                .required("Please confirm account number"),
        }),
    }

    const normalizedStepName = typeof stepName === "string"
        ? stepName.trim().toLowerCase().replace(/\s+/g, "_").replace(/-/g, "_")
        : undefined

    return {
        validationSchema: validationSchemas[normalizedStepName] || Yup.object({})
    }
}

export default getValidation
